<script setup lang="ts">
/**
 * A 16px, decorative brand mark for a sign-in provider (#1933): Google, Microsoft or GitHub. It draws the same SVG
 * markup the API's server-rendered invitation page inlines (lib/provider-marks.ts), so the two cannot differ. The
 * markup is a constant of this package, never anything a caller passes in, which is what makes `v-html` safe here.
 *
 * Decorative: the button it sits in says the provider's name, so the mark is `aria-hidden`.
 */
import { computed } from 'vue'
import { PROVIDER_MARKS, type ProviderMarkName } from '../lib/provider-marks'

const props = defineProps<{ provider: ProviderMarkName }>()

const markup = computed(() => PROVIDER_MARKS[props.provider])
</script>

<template>
    <span class="inline-flex shrink-0" aria-hidden="true" v-html="markup" />
</template>
